import React, { ChangeEvent, SelectHTMLAttributes } from "react";
import { LabelValueSet } from "../../../../domain/utility/LabelValueSet";
import classNames from "classnames";

export function InputSelectBox(props: InputSelectBoxParams) {
    const { disabled = false, list, handleSelectBoxChanged, hasError, label, required, ...rest } = props;

    const Label = () => {
        if (!label) return null;

        return (
            <div className="select_box__label">
                {label}{required ? <p className="input_required_label">必須</p> : null}
            </div>
        );

    };

    return (
        <div className="select_box">
            <Label/>
            <div className={classNames("select_box__input", { "disabled": disabled, "error": hasError })}>
                <select
                    disabled={disabled}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { handleSelectBoxChanged(e.target.value); }}
                    {...rest}
                >
                    {list.map((it, i) => (<option key={i} value={it.value}>{it.label}</option>))}
                </select>
            </div>
        </div>
    );
}

export interface InputSelectBoxParams extends SelectHTMLAttributes<HTMLSelectElement> {
    list: LabelValueSet[]
    handleSelectBoxChanged: (value: string) => void
    hasError?: boolean
    label?: string
}
